// Password requirements checklist component
// Displays password requirements with check/cross indicators
// Created: 2024-10-17

import { Check, X } from 'lucide-react';
import { PASSWORD_REQUIREMENTS } from '../../lib/passwordPolicy';

interface PasswordRequirementsChecklistProps {
  password: string;
}

export function PasswordRequirementsChecklist({ password }: PasswordRequirementsChecklistProps) {
  if (!password) return null;

  return (
    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
      <p className="text-xs font-semibold text-gray-700 mb-2">Exigences du mot de passe :</p>
      <div className="space-y-1.5">
        {PASSWORD_REQUIREMENTS.map((req) => {
          const isMet = req.test(password);
          return (
            <div key={req.id} className="flex items-center gap-2">
              {isMet ? (
                <Check size={14} className="text-green-600 flex-shrink-0" />
              ) : (
                <X size={14} className="text-gray-400 flex-shrink-0" />
              )}
              <span
                className={`text-xs ${
                  isMet ? 'text-green-700 font-medium' : 'text-gray-600'
                }`}
              >
                {req.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
